export default {
  title: "Sorry, something's gone wrong",
  description: 'Here are the error details'
};
